import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {Flex, Text, Button} from '@salesforce/retail-react-app/app/components/shared/ui'
import {Link as RouterLink} from 'react-router-dom'
import {Link as ChakraLink} from '@chakra-ui/react'
import {getGlobalLink} from '../../utils/contentstack-utils'
import {useGetCategoriesData} from '../../custom-api/hooks/use-get-categories-data'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const PopoverThirdLevelCategories = ({third_level_categories = [], isDrawer = false}) => {
    const categoryData = useGetCategoriesData()
    const [hoveredCategory, setHoveredCategory] = useState(null)
    const {locale} = useMultiSite()

    const handleCategoryHover = (categoryUid) => {
        setHoveredCategory(categoryUid)
    }

    const handleCategoryExit = () => {
        setHoveredCategory(null)
    }

    return (
        <Flex w="100%" flexDir="column" gap="small.base" marginTop="medium.lg">
            {!isDrawer && <Text visibility="hidden"></Text>}
            <Flex
                flexDir="column"
                justifyContent="flex-start"
                gap="xsmall.base"
                alignSelf="stretch"
                onMouseLeave={handleCategoryExit}
            >
                {third_level_categories.map((category) => {
                    const {url, label, isAbsolute} =
                        getGlobalLink({
                            link: category,
                            categoriesData: categoryData,
                            locale: locale?.alias,
                        }) || {}
                    const commonProps = {
                        key: category?._metadata?.uid,
                        textStyle: 'body-small',
                        fontWeight: '400',
                        onMouseEnter: () => handleCategoryHover(category?._metadata?.uid),
                        color:
                            category?._metadata?.uid === hoveredCategory
                                ? 'text.tertiary'
                                : 'text.default',
                    }

                    if (url) {
                        return (
                            <Button
                                key={category?._metadata?.uid}
                                {...commonProps}
                                as={isAbsolute ? ChakraLink : RouterLink}
                                href={isAbsolute ? url : undefined}
                                to={!isAbsolute ? url : undefined}
                                target={isAbsolute ? '_blank' : undefined}
                                rel={isAbsolute ? 'noopener noreferrer' : undefined}
                                textDecoration="none"
                                _hover={{textDecoration: 'none'}}
                                whiteSpace="normal"
                                wordBreak="break-word"
                            >
                                {label}
                            </Button>
                        )
                    }

                    return (
                        <Button
                            as="a"
                            key={category?._metadata?.uid}
                            {...commonProps}
                            whiteSpace="normal"
                            wordBreak="break-word"
                        >
                            {label}
                        </Button>
                    )
                })}
            </Flex>
        </Flex>
    )
}

PopoverThirdLevelCategories.propTypes = {
    third_level_categories: PropTypes.array,
    isDrawer: PropTypes.bool,
}

export default PopoverThirdLevelCategories
